/**
 * Console Filter Utility
 *
 * This utility intercepts console warnings and errors to hide noisy third-party
 * messages that are not actionable or relevant to the application's stability.
 */

const NOISY_PATTERNS = [
  // TikTok / ByteDance SDK
  "Volume control is not supported for TikTok videos",
  "@ies/starling_intl",
  "Consume appContext before init",
  "webmssdk.js",
  "webmssdk_ex.js",
  "sdk is ready, version is",
  "appid:",
  "userInfo:",
  "you can report now",

  // Browser / Environment / Violations
  "Permissions policy violation: unload",
  "getInstalledRelatedApps()",
  "top-level browsing contexts",

  // Facebook / Meta SDK
  "FeatureGateClients",
  "No storage available for session",
  "We will not send any data",
  "vendor-6-",
  "vendor-21-",

  // Video Players / React Player
  "Player w/ mediaElement has been deprecated",
  "streaming.useNativeHlsOnSafari",
  "streaming.useNativeHlsForFairPlay",
  "streaming.preferNativeHls",
];

/**
 * Checks if any argument contains a noisy pattern.
 */
function isNoisy(args) {
  return args.some((arg) => {
    const str = String(arg);
    return NOISY_PATTERNS.some((pattern) => str.includes(pattern));
  });
}

export function initConsoleFilter() {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (isNoisy(args)) return;
    originalWarn(...args);
  };

  const originalError = console.error;
  console.error = (...args) => {
    if (isNoisy(args)) return;
    originalError(...args);
  };

  const originalLog = console.log;
  console.log = (...args) => {
    if (isNoisy(args)) return;
    originalLog(...args);
  };

  // Also intercept console.debug and info if they are being used
  const originalInfo = console.info;
  console.info = (...args) => {
    if (isNoisy(args)) return;
    originalInfo(...args);
  };
}
